import React from 'react';
import { compose } from 'redux';
import { injectIntl } from '../../util/reactIntl';

import css from './MultiPurposeInfo.css';

const MultiPurposeInfoComponent = props => {
  const { showWarning, warningMessage, icon, useRed } = props;

  return showWarning ? (
    <div className={useRed ? css.warningContainerRed : css.warningContainer}>
      <div className={useRed ? css.iconRed : css.icon}>{icon}</div>
      <p className={css.warningMessage}>{warningMessage}</p>
    </div>
  ) : null;
};

const MultiPurposeInfo = compose(injectIntl)(MultiPurposeInfoComponent);

export default MultiPurposeInfo;
